
import {Component, Vue} from "vue-property-decorator";
import {TaskDurum} from "@/plugins/uyap-plugin/enum/TaskDurum";
import {ITask, ITasks, PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {Socket} from "vue-socket.io-extended";

@Component({
  components: {}
})
export default class TopluHacizGonderIslemDetayView extends Vue {
  @Socket('updateTasks')
  onUpdateTask() {
    this.load();
  }

  onFly = false;
  downloading = false;
  headers = [
    {text: 'Esas No', value: 'esasNo'},
    {text: 'Birim Adı', value: 'birimAdi'},
    {text: 'Borçlu', value: 'borclu'},
    {text: 'Durum', value: 'status'},
  ];
  seciliHataliGorevler = [];
  items = [];
  loading = false;
  hataliHeaders = [
    {text: 'Esas No', value: 'esasNo'},
    {text: 'Birim Adı', value: 'birimAdi'},
    {text: 'Borçlu', value: 'borclu'},
    {text: 'Açıklama', value: 'description'},
    {text: 'Durum', value: 'status'},
  ];
  taskDurum = TaskDurum;
  programPaths = ProgramPaths;
  playerDurum = PlayerDurum;

  /** Sağdaki tabloda listelenen, yeniden başlatılabilen ya da yeniden başlatılmış görevler. */
  get hataliItems(): Array<ITask> {
    return this.items.filter((item: ITask) => item.status === this.taskDurum.BITTI_HATALI ||
        item.status === this.taskDurum.BITTI_EKSIK || item.status === this.taskDurum.YENIDEN_BASLATILDI);
  }

  get isFirstTask(): boolean {
    return this.$store.getters.getSiradakiGorevler[0]?.id == this.$route.params.id;
  }

  get paternTask(): ITask {
    let tasks: ITasks = this.$store.getters.getGorevler;
    let allTaskt: Array<ITask> = [...tasks.incomplete_tasks, ...tasks.completed_tasks];
    return allTaskt.find((task: ITask) => task.id == Number(this.$route.params.id)) as ITask;
  }

  async mounted() {
    await this.load()
  }

  async load() {
    try {
      this.loading = true;
      this.items = (await this.$http.get('/api/v1/task/' + this.$route.params.id + '/child-tasks')).data;
    } catch (e) {
      this.items = [];
    } finally {
      this.loading = false;
    }
  }

  downloadExcel() {
    this.downloading = true;
    this.$helper.download('Excel Sonuçlar.xlsx', '/api/v1/export-to-excel/' + this.$route.params.id).finally(() => {
      this.downloading = false;
    });
  }

  async durdurDevamEt() {
    if (this.$store.getters.getPlayerDurum == this.playerDurum.oto) {
      this.$socket.client.emit("player", this.playerDurum.durduruluyor);
    } else {
      await this.$store.dispatch("playerBaslatOnayli", this.$socket.client);
    }
  }

  selectAllToggle() {
    let hatalilar = this.items.filter((item: ITask) => (item.status == this.taskDurum.BITTI_HATALI || item.status == this.taskDurum.BITTI_EKSIK));
    if (this.seciliHataliGorevler.length == hatalilar.length) {
      this.seciliHataliGorevler = [];
    } else {
      this.seciliHataliGorevler = hatalilar;
    }
  }

  async tryAgainCreateTask() {
    // Yeniden başlatılmış görev ikinci kez başlatılırsa aynı talepler iki kez gönderilir.
    this.seciliHataliGorevler = this.seciliHataliGorevler.filter((item: ITask) =>
        item.status == this.taskDurum.BITTI_HATALI || item.status == this.taskDurum.BITTI_EKSIK);
    if (this.seciliHataliGorevler.length > 0) {
      this.onFly = true;
      let tasks: Array<ITask> = [];
      this.seciliHataliGorevler.forEach((item: any) => {
        let task: ITask = {...item};
        task.id = null;
        task.status = TaskDurum.SIRADA;
        task.response = null;
        task.parent_id = null;
        // Handler UYAP'a gitmiş talepleri response'a yazar. Yeni görev eski sonucu alır;
        // gitmiş talepleri atlayıp yalnızca gönderilemeyenleri gönderir.
        if (item.response?.gonderilenTalepAnahtarlari)
          task.data = {...item.data, oncekiGonderim: item.response};
        tasks.push(task);
      });
      tasks[0].aciklama = "Gönderilemeyen haciz taleplerinin gönderilmesi."
      try {
        await this.$store.dispatch('postTasks', tasks);
        let req = {
          ids: this.seciliHataliGorevler.map((gorev: ITask) => gorev.id),
          status: TaskDurum.YENIDEN_BASLATILDI
        };
        await this.$http.post('/api/v1/task/update-status', req);
        await this.$store.dispatch('getTasksFromServer');
        await this.load();
        await this.$router.push(ProgramPaths.eicrapro + '/islemler');
      } catch (e) {
        console.error(e)
        // Yeni görev oluşup eski görev işaretlenememiş olabilir; kullanıcı fark etmeden ikinci
        // kez başlatırsa aynı talepler iki kez gönderilir.
        this.$toast.error('Yeniden başlatma tamamlanamadı. Tekrar denemeden önce İşlemler listesini kontrol ediniz.');
      } finally {
        this.seciliHataliGorevler = [];
        this.onFly = false;
      }
    } else {
      this.$toast.info('Yeniden başalatılacak görevleri seçiniz.')
    }
  }
}
